import moment from 'moment'

import 'moment/locale/nl'

export default (ctx, inject) => {
  ctx.$moment = moment
  inject('moment', moment)
}
